module.exports = __webpack_public_path__ + "img/icone-coa-historical.6de50855.svg";